module.exports = __webpack_public_path__ + "img/a16.1d3deaf0.jpg";